<script setup lang="ts">
/********************
 * PROPS & EMITS     *
 ********************/
export interface CiDjangoErrorMessagesProps {
  errors?: any;
}
const props = withDefaults(defineProps<CiDjangoErrorMessagesProps>(), {
  errors: () => ({}),
});

/********************
 * COMPOSITIONS      *
 ********************/
const { $gettext } = useGettext();

/********************
 * REFS & VARS       *
 ********************/
const errors = computed(() => {
  const arr = [];
  if (props.errors) {
    if (typeof props.errors === 'string') {
      /*
       * Simple error message as a string
       */

      arr.push(props.errors);
    } else if (props.errors instanceof Array) {
      /*
       * multiple complex django errors wrapped inside an array (e.g. video upload)
       */
      for (let i = 0; i < props.errors.length; i += 1) {
        extractErrors(props.errors[i], arr);
      }
    } else if (typeof props.errors === 'object') {
      extractErrors(props.errors, arr);
    }
  }

  return arr;
});

/********************
 * FUNCTIONS         *
 ********************/
function extractErrors(data, target) {
  for (const [field, errorObj] of Object.entries(data)) {
    if (field === 'message') {
      /*
       * Custom error message style as an object, e.g.
       *
       * {
       *  "message": "...",
       *  "code": "..."
       * }
       *
       */
      target.push(errorObj);
    } else if (errorObj instanceof Array) {
      /*
       * Default django error messages (more complex), e.g.
       *
       * {
       *  "field": [
       *    { "message": "...", "code": "..."},
       *    { "message": "...", "code": "..."}
       *  ],
       * }
       *
       */
      for (let i = 0; i < errorObj.length; i += 1) {
        target.push(errorObj[i].message);
      }
    }
  }
}
</script>

<template>
  <div class="text-left">
    <div translate-comment="This appears as an error list headline globally">
      {{ $gettext('The following error(s) occurred:') }}
    </div>
    <ul
      id="error-messages"
      class="mb-0"
    >
      <li
        v-for="message in errors"
        :key="message"
      >
        {{ message }}
      </li>
    </ul>
  </div>
</template>
